import { motion } from "framer-motion";

const reviews = [
  {
    name: "Rahul Sharma",
    rating: 5,
    text: "Excellent guidance throughout the process. Very professional team.",
  },
  {
    name: "Ananya Verma",
    rating: 5,
    text: "Smooth experience and timely support. Highly recommended.",
  },
  {
    name: "Karthik R",
    rating: 4,
    text: "Clear communication and genuine advice. Helped me a lot.",
  },
];

/* ===== PREMIUM WORDPRESS-STYLE VARIANTS ===== */

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.15,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    scale: 0.96,
    filter: "blur(6px)",
  },
  visible: {
    opacity: 1,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1], // premium easing
    },
  },
};

export default function Testimonialsdummy() {
  return (
    <section className="py-24 bg-[#b4d7fa] overflow-hidden">
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1],
        }}
        className="text-center mb-16"
      >
        <h2 className="text-3xl font-bold text-gray-900">
          What Our <span className="text-[#000000]">Clients Say</span>
        </h2>
        <p className="mt-3 text-sm text-gray-500">
          Reviews from our recent clients
        </p>
      </motion.div>

      {/* Cards */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8"
      >
        {reviews.map((review, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            className="
              relative bg-white rounded-2xl p-8
              shadow-md border border-blue-200/60
              transition-shadow duration-500
              hover:shadow-lg
            "
          >
            {/* Stars */}
            <div className="flex mb-4 text-yellow-400">
              {"★".repeat(review.rating)}
              {"☆".repeat(5 - review.rating)}
            </div>

            {/* Text */}
            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              “{review.text}”
            </p>

            {/* Name */}
            <p className="font-semibold text-gray-800">
              {review.name}
            </p>

            {/* Soft hover glow */}
            <span className="pointer-events-none absolute inset-0 rounded-2xl bg-gradient-to-br from-[#2596BE]/10 to-transparent opacity-0 hover:opacity-100 transition duration-500" />
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
